var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplymainintromobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 163,
    viewBox: "0 0 112 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.496 80.826c2.305 3.414 4.864 7.161 6.66 9.781 1.996-7.113-.67-17.053-3.645-24.484-.724 4.62-1.715 9.511-3.015 14.703zM46.452 54.5c-2.961 3.367-5.614 9.654-3.618 19.483 1.796-.175 4.342-.413 6.646-.667-1.313-6.986-2.304-13.226-3.028-18.816z",
    fill: "#FF062E",
    fillOpacity: 0.56
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.816 89.512C36.267 14.154 49.882 7.755 55.027 5.183c5.146 9.622 18.76 34.646 2.184 87.33l-4.395-3.001z",
    fill: "url(#5sw320aeua)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.695 85.177C41.133 9.835 54.747 3.437 59.906.848c5.146 9.622 18.76 34.646 2.184 87.33l-4.395-3.001z",
    fill: "url(#0yni24kumb)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M57.211 92.513c16.576-52.684 2.962-77.708-2.184-87.33V91.02l2.184 1.493z",
    fill: "url(#d1bmb8vw6c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.973 31.715c0 4.59-2.278 6.749-5.092 4.827-2.814-1.92-5.092-7.208-5.092-11.797s2.278-6.748 5.092-4.827c2.814 1.921 5.092 7.209 5.092 11.797z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.988 144.148c2.76 7.193 6.874 13.385 11.47 16.529 8.308 5.685 15.048-.73 15.061-14.322 0-13.591-6.74-29.231-15.047-34.916-2.734-1.873-5.293-2.429-7.504-1.858-1.166-2.254-1.729-5.112-2.225-7.621-.576-2.89-1.058-5.351-2.264-5.97-1.38-.715-1.997 1.095-2.867 3.604-.51 1.477-1.113 3.223-1.997 4.827-.952-1.191-1.956-2.175-3.015-2.89-4.435-3.032-8.134-.413-9.005 5.843a19.142 19.142 0 0 0-1.822-1.46c-7.115-4.859-12.877.651-12.877 12.337 0 11.67 5.762 25.071 12.864 29.93 6.9 4.716 12.542-.349 12.863-11.321 1.3 2.858 3.029 5.256 4.945 6.558.469.317.951.555 1.42.73z",
    fill: "url(#cxnuh19k2d)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m72.34 57.58 36.287 24.818.014 22.404-33.07-22.626-3.203 1.238-.027-25.833z",
    fill: "url(#wsvfi26cre)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.067 86.336v-6.081l13.695 9.368v6.081l-13.695-9.368z",
    fill: "#FF062E",
    fillOpacity: 0.56
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m81.679 69.41 7.946 5.446v1.97l-7.946-5.431V69.41zM81.68 73.348l14.351 9.812v1.97l-14.35-9.813v-1.97z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m81.68 77.285 18.558 12.703v1.969L81.68 79.254v-1.969z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.723 70.124c0 1.842-.925 2.716-2.064 1.938-1.139-.778-2.063-2.906-2.063-4.748s.924-2.715 2.063-1.937c1.14.778 2.064 2.906 2.064 4.747z",
    fill: "#FF062E",
    fillOpacity: 0.56
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M41.053 25.935 4.78 1.134l.013 22.404 33.07 22.61 3.203 5.621-.013-25.834z",
    fill: "url(#5cgxge99hf)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M.919 9.867V3.786l13.694 9.368v6.081L.92 9.867z",
    fill: "#FF062E",
    fillOpacity: 0.71
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m31.727 25.015-7.947-5.43v1.968l7.947 5.43v-1.968zM31.738 28.952l-15.316-10.48v1.97l15.316 10.48v-1.97zM31.738 32.89 13.18 20.187v1.97l18.558 12.702V32.89z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.697 28.397c0 1.841.925 3.97 2.064 4.747 1.139.778 2.063-.095 2.063-1.937s-.924-3.97-2.063-4.748c-1.153-.762-2.077.096-2.064 1.938z",
    fill: "#FF062E",
    fillOpacity: 0.56
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.227 49.848 14.559 35.034v13.37l21.668 14.813V49.848z",
    fill: "url(#1w06k1d8rg)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m20.108 42.036 7.423 5.081v1.604l-7.423-5.081v-1.604zM20.122 45.26l13.882 9.494v1.62l-13.882-9.495v-1.62z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.969 42.512c0 1.096-.55 1.62-1.233 1.16-.683-.461-1.233-1.731-1.233-2.843 0-1.095.55-1.62 1.233-1.159.683.477 1.233 1.747 1.233 2.842z",
    fill: "#FF062E",
    fillOpacity: 0.56
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.586 59.947 78.919 45.132v13.37l21.667 14.83V59.947z",
    fill: "url(#kvtp43gjuh)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m84.467 52.15 7.424 5.081v1.604l-7.424-5.08V52.15zM84.466 55.373l13.882 9.496v1.62l-13.882-9.496v-1.62z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M83.328 52.627c0 1.095-.55 1.62-1.233 1.159-.683-.46-1.232-1.731-1.232-2.843 0-1.095.549-1.619 1.232-1.159.684.46 1.233 1.747 1.233 2.843z",
    fill: "#FF062E",
    fillOpacity: 0.56
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5sw320aeua",
    x1: 74.34,
    y1: 7.855,
    x2: 21.218,
    y2: 85.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0yni24kumb",
    x1: 79.218,
    y1: 3.521,
    x2: 26.096,
    y2: 81.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d1bmb8vw6c",
    x1: 66.572,
    y1: 26.501,
    x2: 25.339,
    y2: 89.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cxnuh19k2d",
    x1: 63.549,
    y1: 109.441,
    x2: 40.604,
    y2: 142.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wsvfi26cre",
    x1: 87.931,
    y1: 58.306,
    x2: 94.477,
    y2: 103.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5cgxge99hf",
    x1: 33.147,
    y1: 16.964,
    x2: 12.116,
    y2: 30.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1w06k1d8rg",
    x1: 27.839,
    y1: 44.104,
    x2: 21.607,
    y2: 53.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kvtp43gjuh",
    x1: 92.193,
    y1: 54.215,
    x2: 85.961,
    y2: 63.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplymainintromobile);
export default __webpack_public_path__ + "static/media/Apply main intro mobile.ac5b98cd909c4baa3531ef8153c3c5e8.svg";
export { ForwardRef as ReactComponent };